<template>
  <div class="" id="admin_dashboard">
    <SidePageColumn side="right">
      <div class="text-left">
        <template v-for="(menu_item, index) in sub_menu_items">
          <NavbarMenuItem
            v-if="can_access(menu_item)"
            :key="index"
            :to="menu_item.to"
            :icon="menu_item.icon"
            :label="menu_item.label"
          ></NavbarMenuItem>
        </template>
      </div>
      <v-divider
        class="mt-4"
        v-if="attrs.right_quick_links.length > 0"
      ></v-divider>
      <QuickSideLinks
        :quick_links="attrs.right_quick_links"
        v-if="attrs.right_quick_links.length > 0"
      ></QuickSideLinks>
    </SidePageColumn>
    <CenterNavbar
      :crumps="attrs.crumps"
      :title="attrs.title"
      :width_class="page_info.center_width_class"
      :show_staff="true"
      :navbar_cols="attrs.navbar_cols ? attrs.navbar_cols : 4"
    ></CenterNavbar>
    <div class="inner-page-container">
      <div class="d-flex justify-space-around white pt-5">
        <DasboardBoxWidget
          :is_loading="is_loading"
          color="purple"
          :num_text="comma(dashboard.num_users)"
          sub_text="system"
          main_text="users"
          link="/admin/users/list"
          icon="mdi-account-group"
        ></DasboardBoxWidget>
        <DasboardBoxWidget
          :is_loading="is_loading"
          color="warning"
          :num_text="comma(dashboard.num_businesses)"
          sub_text="registered"
          main_text="businesses"
          link="/admin/businesses/list"
          icon="mdi-home-city-outline"
        ></DasboardBoxWidget>
        <DasboardBoxWidget
          :is_loading="is_loading"
          color="success"
          :num_text="comma(dashboard.num_promotions)"
          sub_text="created"
          main_text="promotions"
          link="/admin/promotions/list"
          icon="mdi-bullhorn"
        ></DasboardBoxWidget>
        <DasboardBoxWidget
          :is_loading="is_loading"
          color="info"
          :num_text="comma(dashboard.num_adverts)"
          sub_text="posted"
          main_text="adverts"
          link="/admin/adverts/list"
          icon="mdi-television"
        ></DasboardBoxWidget>
      </div>
      <v-row no-gutters class="white pt-5">
        <v-col cols="8 pl-8 pb-10">
          <div class="grey lighten-5 round-4 elevation-4">
            <div class="pt-1 pb-1">
              <b>Trend Of Business Searching Activity</b> (past 30 days)
            </div>
            <v-divider></v-divider>
            <SparklineGraph
              :value="dashboard.business_searches_graph_value"
              :labels="dashboard.business_searches_graph_labels"
              type="trend"
              :height="70"
              :label_size="5"
            >
            </SparklineGraph>
            <v-divider></v-divider>
            <v-btn
              block
              small
              text
              :disabled="is_loading"
              color="primary"
              class="mt-0"
              :to="'/admin/reports/searches/activity'"
            >
              Go To Search Report
              <v-icon right>mdi-arrow-right</v-icon>
            </v-btn>
            <div class="pt-1 pb-1 mt-5">
              <b>Trend Of Business Views</b> (past 30 days)
            </div>
            <v-divider></v-divider>
            <SparklineGraph
              :value="dashboard.business_views_graph_value"
              :labels="dashboard.business_views_graph_labels"
              type="trend"
              :height="70"
              :label_size="5"
            >
            </SparklineGraph>
            <v-divider></v-divider>
            <v-btn
              block
              small
              text
              :disabled="is_loading"
              color="primary"
              class="mt-0"
              :to="'/admin/reports/views/activity'"
            >
              Go To View Report
              <v-icon right>mdi-arrow-right</v-icon>
            </v-btn>
          </div>
        </v-col>
        <v-col cols="4" class="pl-2 pr-8 pb-10">
          <div class="grey lighten-3 round-4 elevation-4">
            <div class="pt-1 pb-1">
              <b>Registration Goal</b> <small>({{comma(page_info.registration_goal)}})</small>
            </div>
            <v-divider></v-divider>
            <div class="goal-widget pr-2 pl-2 pt-5 pb-5 ">
              <v-progress-circular
                :size="120"
                :width="18"
                :value="dashboard.registration_goal_percentage"
                color="teal"
              >
                {{comma(dashboard.registration_goal_percentage)}} %
              </v-progress-circular>
            </div>
            <v-divider></v-divider>
            <div class="pt-1 pb-1 mt-12">
                <b>Advert Goal</b> <small>({{comma(page_info.ad_goal)}})</small>
            </div>
            <v-divider></v-divider>
            <div class="goal-widget pr-2 pl-2 pt-5 pb-5">
              <v-progress-circular
                :size="120"
                :width="18"
                :value="dashboard.advert_goal_percentage"
                color="teal"
              >
                {{comma(dashboard.advert_goal_percentage)}}%
              </v-progress-circular>
            </div>
            <v-btn
              block
              small
              text
              :disabled="is_loading"
              color="primary"
              class="mt-0"
              :to="'/admin/adverts/list'"
            >
              View Adverts
              
              <v-icon right>mdi-arrow-right</v-icon>
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import SidePageColumn from "./../../components/SidePageColumn";
import SparklineGraph from "./../../components/SparklineGraph";
import QuickSideLinks from "./../../components/QuickSideLinks";
import Utils from "./../../lib/Utils";
import ServerClient from "./../../lib/ServerClient";
import NavbarMenuItem from "./../../components/NavbarMenuItem";
import CenterNavbar from "./../../components/CenterNavbar";
import DasboardBoxWidget from "./../../components/DasboardBoxWidget";

import page_info from "./../../lib/page_info";
export default {
  name: "AdminDashboard",
  components: {
    SidePageColumn,
    NavbarMenuItem,
    CenterNavbar,
    QuickSideLinks,
    DasboardBoxWidget,
    SparklineGraph,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      default: false,
    },
  },
  data: () => {
    return {
      _user: null,
      sub_menu_items: [],
      page_info: page_info,
      attrs: Utils.get_default_page_attr(),
      dashboard: {
        num_users: 0,
        num_businesses: 0,
        num_promotions: 0,
        num_adverts: 0,
        business_views_graph_value: [],
        business_views_graph_labels: [],
        business_searches_graph_value: [],
        business_searches_graph_labels: [],
        advert_goal_percentage: 0,
        registration_goal_percentage: 0
      },
    };
  },
  methods: {
    can_access(menu_item) {
      var res = Utils.can_access(this.user, menu_item);
      return res;
    },
    comma(v){
      if(v < 10){
        v = "0" + v.toString();
      }
      return Utils.add_commas(v);
    },
    load_items() {
      var today_date = new Date();
      var month_ago_date = today_date.addDays(-30);

      var start_time_str =
        Utils.get_today_date_str(month_ago_date) + " 00:30:00 AM ";
      var start_time = Utils.date_str_to_php_time(start_time_str);

      var end_time_str = Utils.get_today_date_str(today_date) + " 11:30:00 PM ";
      var end_time = Utils.date_str_to_php_time(end_time_str);

      this.$emit("on-show-loader");
      ServerClient.Dashboards.get_admin_dashboard(
        {
          id: this._user.id,
          start_time_stamp: start_time,
          end_time_stamp: end_time,
        },
        (res) => {
          var temp_db = res;
          //process views graph
          var plot_items = Utils.process_promo_graph_data(
            Utils.get_today_date_str(month_ago_date),
            Utils.get_today_date_str(today_date),
            temp_db.business_views_graph_value,
            false
          );
          temp_db.business_views_graph_value = plot_items.values;
          temp_db.business_views_graph_labels = plot_items.labels;
          //search graph
          var search_plot_items = Utils.process_promo_graph_data(
            Utils.get_today_date_str(month_ago_date),
            Utils.get_today_date_str(today_date),
            temp_db.business_searches_graph_value,
            false,
            "posted_on"
          );
          temp_db.business_searches_graph_value = search_plot_items.values;
          temp_db.business_searches_graph_labels = search_plot_items.labels;
          //goals 
          var temp_rg = Math.ceil((parseFloat(temp_db.num_businesses)/parseFloat(page_info.registration_goal))*100);
          temp_db.registration_goal_percentage = temp_rg;
          var temp_ag = Math.ceil((parseFloat(temp_db.num_adverts)/parseFloat(page_info.ad_goal))*100);
          temp_db.advert_goal_percentage = temp_ag;
          

          this.dashboard = temp_db;
          this.$emit("on-hide-loader");
        },
        (errors) => {
          console.log("Errors while loading business dashboard ", errors);
          this.$emit("on-hide-loader");
        }
      );
    },
  },
  mounted() {
    this._user = ServerClient.Login.get_logged_in_user();

    this.attrs = {
      title: "Admin DashBoard",
      crumps: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin",
        },
        {
          text: "Dashboard",
          disabled: true,
          href: "/admin/dashboard",
        },
      ],
      right_quick_links: [],
    };

    var options = {
      offset: 50,
      duration: 1000,
      easing: "easeInOutCubic",
    };
    this.$vuetify.goTo("#admin_dashboard", options);
    this.load_items();
  },
};
</script>